module.exports = __webpack_public_path__ + "img/geniegroup.37a35de0.png";